import React from 'react';
import { bool, string } from 'prop-types';
import ReactPlayer from 'react-player/youtube';

import css from './VideoPlayer.module.css';


const VideoPlayer = props => {
  const { videoURL, controls, videoWidth, videoHeight} = props;

  return (
    <>
      {videoURL !== null && (typeof window !== 'undefined') ? 
        <div className={css.videoPlayer}>
          <ReactPlayer 
            url={videoURL}
            className='react-player'
            controls={controls}
            width= {videoWidth}
            height= {videoHeight}
            config={{
              youtube: {
                playerVars: { origin: window.location.host}
              },
              file: { 
                attributes: { 
                  poster: './poster.jpg'
                } 
              } 
            }}
          />
        </div>
      : null}
    </>
  );
};

VideoPlayer.defaultProps = {
  videoURL: null, 
  controls: null, 
  videoWidth: null, 
  videoHeight: null,
  currentUserListing: null,
};

VideoPlayer.propTypes = {
  videoURL: string, 
  controls: bool, 
  videoWidth: string, 
  videoHeight: string,
  rootClassName: string,
  className: string,
};
export default VideoPlayer;
